import ProductCompareHelper from "../helpers/productCompareHelper";
import Splide from '@splidejs/splide';
import { createApp } from 'vue';
import Cookies from 'js-cookie'
import Modal from "./vueComponents/Modal.vue";
import InputCheckbox from "./vueComponents/InputCheckbox.vue";
import EllipseComponent from "./vueComponents/EllipseComponent.vue";
import ProductCompareParam from "./vueComponents/ProductCompareParam.vue";

const _ = require('lodash');

const axios = require('axios');

export default {
    name      : 'results',
    _apiUrl   : null,

    init() {
        const selector = '[data-results]';
        const container = document.querySelector(selector);

        if (!container) {
            return;
        }
        
        const handle  = container.getAttribute('data-results');
        const baseUrl = container.getAttribute('data-base_url');
        const apiUrl  = `${baseUrl}actions/ck/${_.kebabCase(handle)}/index`;

        const app = createApp({
            delimiters: ['${', '}'],
            data() {

                return {
                    // Generic config
                    loading: true,
                    isMobile: null,
                    handle              : handle,
                    apiUrl              : apiUrl,
                    query               : '',           // search query in filters input
                    queryTimeout        : null,         // is set while waiting for user to stop typing in search bar
                    offset              : 0,            // offset of pagination (which page am I viewing)
                    limit               : 18,           // amount of products to show per page
                    pagesVisible        : 7,            // amount of pages visible at the same time in the pagination
                    state               : 1,            // page number being set as we update history
                    filtersModalOpen    : false,
                    // Products
                    products            : [],           // all products
                    filteredProducts    : [],           // limited amount of products based on selected filters


                    // products comparing
                    productsToCompareHtml  : null,
                    productsToCompare      : [],
                    productsToCompareIds   : [],
                    compareModalOpen       : false,
                    modalLayerParams       : null,
                    productCompareConfig   : [],
                    searchToCompareResults : [],
                    searchToCompareQuery   : [],
                    showProductsDiff       : false,

                    // chassisList         : null,

                    // List of all filter attributes on fetched products
                    allBrands           : [],
                    allDomains          : [],
                    allSeries           : [],
                    allRetailers        : [],
                    allLocations        : [],
                    allSalesforms       : [],
                    allCertificates     : [],
                    allGearboxes        : [],
                    allWheeldrives      : [],
                    allProductTypes     : [],
                    allFuels            : [],
                    allEquipments       : [],
                    allChassis          : [],
                    allCampaigns        : [],

                    // Selected checkbox filter values
                    selectedBrands      : [],
                    selectedDomains     : [],
                    selectedSeries      : [],
                    selectedRetailers   : [],
                    selectedLocations   : [],
                    selectedSalesforms  : [],
                    selectedCertificates: [],
                    selectedGearboxes   : [],
                    selectedWheeldrives : [],
                    selectedProductTypes: [],
                    selectedFuels       : [],
                    selectedEquipments  : [],
                    selectedCampaigns   : [],
                    selectedChassis     : [],
                    // available chechboxes
                    availableSalesforms  : [],

                    // "From - to" filter values
                    price               : {from: null, to: null},
                    distance            : {from: null, to: null},
                    year                : {from: null, to: null},
                    weight              : {from: null, to: null},
                    noOfBeds            : {from: null, to: null},
                    seats               : {from: null, to: null},
                    horsepower          : {from: null, to: null},
                    carryWeight         : {from: null, to: null},
                    length              : {from: null, to: null},

                    // If there are more than 7 checkboxes, a show more link is displayed. These booleanss handle the toggle
                    showAllFilters      : false,
                    showAllBrands       : false,
                    showAllDomains      : false,
                    showAllRetailers    : true,
                    showAllLocations    : true,
                    showAllSalesforms   : false,
                    showAllCertificates : false,
                    showAllGearboxes    : false,
                    showAllWheeldrives  : false,
                    showAllProductTypes : false,
                    showAllFuels        : false,
                    showAllEquipments   : true,
                    showAllChassis      : true,
                    showAllCampaigns    : true,
                    showAllBrandSeries  : true,

                    listType            : 'board',      // 'board' is a grid view of product, 'list' is one product per line
                    sortDir             : 'descDate',   // how to sort the products, default 'descDate' is new to old
                    sortList            : false,        // toggle the sorting options popup modal
                    imageTypeList       : false,        // toggle the image type,
                    imageType           : 'gallery',        // toggle the image type,

                    // Data for condensing functions
                    checkboxes: [
                        {name: 'Brands',       key: 'br', value: false, cert: false},
                        {name: 'Series',       key: 'pl', value: false, cert: false},
                        {name: 'Domains',      key: 'ds', value: false, cert: false},
                        {name: 'Retailers',    key: 'rn', value: false, cert: false},
                        {name: 'Locations',    key: 'rc', value: false, cert: false},
                        {name: 'Salesforms',   key: 'sf', value: false, cert: false},
                        {name: 'Certificates', key: 'wt', value: false, cert: true },
                        {name: 'Gearboxes',    key: 'tr', value: true,  cert: false},
                        {name: 'Wheeldrives',  key: 'wd', value: true,  cert: false},
                        {name: 'ProductTypes', key: 'pt', value: false, cert: false},
                        {name: 'Fuels',        key: 'f',  value: false, cert: false},
                        {name: 'Equipments',   key: 'e',  value: false, cert: false},
                        {name: 'Campaigns',    key: 'c',  value: false, cert: false},
                        {name: 'Chassis',      key: 'ch', value: false, cert: false},
                    ],

                    fromTos: [
                        {name: 'price',       key: 'p',  value: false},
                        {name: 'distance',    key: 'm',  value: false},
                        {name: 'year',        key: 'y',  value: false},
                        {name: 'weight',      key: 'w',  value: false},
                        {name: 'noOfBeds',    key: 'b',  value: false},
                        {name: 'seats',       key: 's',  value: true },
                        {name: 'horsepower',  key: 'hp', value: false},
                        {name: 'carryWeight', key: 'py', value: true },
                        {name: 'length',      key: 'l',  value: false},
                    ]
                }
            },
            updated() {
                if(window.PC_SWIPER){
                    window.PC_SWIPER.update();
                }

                ProductCompareHelper.setLayerParamsHeights();
                ProductCompareHelper.setLayerParamsTitles();

            },
            created() {
                this.run();
            },
            methods: {
                run(){
                    this.convertURLParams();
                    this.parseQueryParams();

                    this.fetchProducts().then(res => {
                        this.loading = false;
                        this.setProductDynamicAttributes();
                        this.makeFilters();
                        this.update();              
                        this.setProductsToCompare();
                        this.cleanDOM();
                    });

                    window.onpopstate = (event) => {
                        this.resetFilters();
                        this.parseQueryParams();
                        this.update(false);
                    }
                    this.checkWindowWidth();
                    this.initWindowScroll();
    
                    window.addEventListener("resize", e => {
                        ProductCompareHelper.setLayerParamsHeights();
                        ProductCompareHelper.setLayerParamsTitles();
                    });  
                  

                },
                handleImageError(event) {
                    const image = event.target;
                    image.remove();
                },
                toLower(string){
                    if(typeof string !== 'string'){
                        return string;
                    }
                    return string.toLowerCase();
                },
                calcDiscount(item, format)
                {
                    const discount = parseInt(item.bp) - parseInt(item.p);

                    return (format) ? this.formatPrice(discount) : discount;
                },
                cleanDOM(){
                    delete document.querySelector(selector).dataset.productCompareConfig;
                },
                getProductCompareConfig(){
                    return JSON.parse(container.dataset.product_compare_config);
                },
                setProductDynamicAttributes(){
                    this.products.forEach(p => {
                        p.toCompare = false;
                    });
                },
                setProductCompareConfig(){
                    let config = this.getProductCompareConfig();

                    this.productCompareConfig = config.filter(config => {
                        return this.productsToCompare.some(product => {
                            if(Array.isArray(product[config['key']])){
                                return product[config['key']].length;
                            }
                            
                            return product[config['key']];
                        });
                    });
                },
                toggleFiltersModal() {
                    const body = document.querySelector('body');
                    body.classList.toggle("no-scroll");

                    this.filtersModalOpen = !this.filtersModalOpen;
                },
                fetchProducts() {
                    let apiUrl = this.apiUrl;
                    return axios({
                        method: "get",
                        url: apiUrl,
                    }).then(res => {
                        this.products = res.data;
                    });
                },
                makeFilters() {
                    this.allBrands       = this.getFilters('br');
                    this.allDomains      = this.getFilters('ds');
                    this.allSeries       = this.getFilters('pl');                  
                    this.allRetailers    = this.getFilters('rn');
                    this.allLocations    = this.getFilters('rc');
                    this.allSalesforms   = this.getFilters('sf');
                    this.allCertificates = this.getFilters('w',  false, true);
                    this.allGearboxes    = this.getFilters('tr', true);
                    this.allWheeldrives  = this.getFilters('wd', true);
                    this.allProductTypes = this.getFilters('pt');
                    this.allFuels        = this.getFilters('f');
                    this.allEquipments   = this.getFilters('e');
                    this.allCampaigns    = this.getFilters('c');
                    this.allChassis      = this.getFilters('ch');
                },
                resetFilters() {
                    this.query                = '';
                    this.listType             = 'board';
                    this.sortDir              = 'descDate';
                    this.sortList             = false;
                    this.selectedBrands       = [];
                    this.selectedDomains      = [];
                    this.selectedSeries       = [];
                    this.selectedRetailers    = [];
                    this.selectedSalesforms   = [];
                    this.selectedCertificates = [];
                    this.selectedGearboxes    = [];
                    this.selectedWheeldrives  = [];
                    this.selectedProductTypes = [];
                    this.selectedFuels        = [];
                    this.selectedEquipments   = [];
                    this.selectedChassis      = [];
                    this.selectedCampaigns    = [];
                    this.price       = {from: null, to: null};
                    this.distance    = {from: null, to: null};
                    this.year        = {from: null, to: null};
                    this.weight      = {from: null, to: null};
                    this.noOfBeds    = {from: null, to: null};
                    this.seats       = {from: null, to: null};
                    this.horsepower  = {from: null, to: null};
                    this.carryWeight = {from: null, to: null};
                    this.length      = {from: null, to: null};
                },
                getFilters(key, value = false, cert = false,) {
                    const items = [];

                    for (const product of this.products) {

                        let  filters = product[key];

                        if (Array.isArray(filters)){
                            filters.forEach(f => {
                                if(!items.includes(f)){
                                    items.push(f);
                                }                     
                            });
                        } else {
                           
                            if (!filters || (value ? !filters.value : false)) {
                                continue;
                            }
                            
                            let filterValue = value     ? filters.value : filters;
                                filterValue = cert      ? this.getCertificate(filterValue) : filterValue;      
                                
                            if (items.indexOf(filterValue) === -1) {   
                                items.push(filterValue);
                            }
                        }
                    }
                    
                    return items;
                },
                getSeriesByBrand(brand){   
                    return this.series[brand];
                },

                inSelected(checkboxName, value) {

                    if(!checkboxName || !value){
                        return;
                    }

                    if(typeof value === 'string' || value instanceof String){
                        value = value.toLowerCase();
                    }

                    if(Array.isArray(value)){
                        return this['selected' + checkboxName].every(r => {
                           return value.some(el => el.toLowerCase() === r.toLowerCase());
                        });
                    }
                     
                    return this['selected' + checkboxName].indexOf(value) !== -1;
                },
                /* TODO, maybe convert to snake case later? */
                convertURLParams() {
                    const currentParams = new URLSearchParams(window.location.search);
                    const newParams = new URLSearchParams();
                  
                    // Loop through the current parameters and convert keys to snake_case
                    for (const [key, value] of currentParams.entries()) {
                      /* const snakeCaseKey = _.snakeCase(key).toLowerCase(); */
                      newParams.set(key, value.toLowerCase());
                    }
                  
                    // Build the new query string
                    const newQueryString = decodeURIComponent(newParams.toString());
                   
                    const newURL = `${window.location.origin}${window.location.pathname}?${newQueryString}`;

                    this.replaceHistory(newURL);
                },
                capitalize(inputString) {
                    if (typeof inputString !== 'string') {
                        return inputString;
                    }
                  
                    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
                },
                parseQueryParams() {
                    const urlSearchParams = new URLSearchParams(window.location.search);
 
                    const params = Object.fromEntries(urlSearchParams.entries());

                    for (const key in params) {
                        let element = params[key];
                        
                        if (element.charAt(0) === '[') {
                            element = JSON.parse(element);
                        } else if (element.includes(',')) {
                            element = element.split(',');
                        }

                        // i.e priceFrom=1000000
                        if (key.includes('From')) {
                            const name      = key.replace('From', '');
                            this[name].from = parseInt(element);

                        // i.e priceTo=1000000
                        } else if (key.includes('To')) {
                            const name    = key.replace('To', '');
                            this[name].to = parseInt(element);

                        } else if (key === 'search') {
                            this.query = element;
                        } else if (key === 'list') {
                            this.listType = 'list';
                        } else if (key === 'sort') {
                            this.sortDir = element;
                            
                        // i.e br=['Hymer','Bürstner']
                        } else if (Array.isArray(element)) {
 
                            const name = this.getCheckboxName(key)
                            if (name) {
                                for (const el of element) {
                                    if (this['selected' + name].indexOf(el) === -1) {
                                        this['selected' + name].push(el);
                                    }
                                }
                            }
                        // i.e br=Hymer
                        } else {
                            
                            element = element === 'true' ? true : element;
                            const name = this.getCheckboxName(key)
                            if (name && this['selected' + name].indexOf(element) === -1) {
                                this['selected' + name].push(element);
                            }
                        }
                    }
                },
                updateQueryParams() {
                    let params = '?';
                    if (this.query) {
                        params += 'search=' + this.query;
                    }
                    if (this.listType !== 'board') {
                        params += params !== '?' ? '&' : '';
                        params += 'list=true';
                    }
                    if (this.sortDir !== 'descDate') {
                        params += params !== '?' ? '&' : '';
                        params += 'sort=' + this.sortDir;
                    }
                    for (const checkbox of this.checkboxes) {
                        if (typeof this['selected' + checkbox.name] !== 'undefined' && this['selected' + checkbox.name].length) {
                            params += params !== '?' ? '&' : '';
                            params += checkbox.key + '=' + this['selected' + checkbox.name].join(',');
                        }
                    }
                    for (const fromTo of this.fromTos) {
                        if (this[fromTo.name].from) {
                            params += params !== '?' ? '&' : '';
                            params += fromTo.name + 'From=' + this[fromTo.name].from;
                        }
                        if (this[fromTo.name].to) {
                            params += params !== '?' ? '&' : '';
                            params += fromTo.name + 'To=' + this[fromTo.name].to;
                        }
                    }
     
                    this.pushHistory(params);
                },
                pushHistory(url){
                    history.pushState({state: this.state}, this.handle, url);
                    this.state++;
                },
                replaceHistory(url){
                    history.replaceState(null, null, url);
                },
                updateFilteredProducts() {
                    let filtered = this.products.slice();
                        filtered = this.matchesCheckboxes(filtered);
                        filtered = this.matchesFromTos(filtered);
                        filtered = this.matchesSearch(filtered);
                        filtered = this.sortProducts(filtered);

                    this.filteredProducts = filtered;
                },
                updateSearch() {
                    if (this.query.length >= 3) {
                        clearTimeout(this.queryTimeout);
                    }

                    this.queryTimeout = setTimeout(() => {
                        this.update();
                    }, 500);
                },

                updateCheckboxFilter(filterName, value) {
                    console.log(`updateCheckboxFilter(${filterName} | ${value})`);
                    this[filterName] = value;
                    this.update();
                },

                update(pushHistory = true) {
                    // console.log('update');
                    // console.log(this.selectedBrands);
                    if(this.selectedBrands.length === 0){
                        this.selectedSeries = [];
                    }

                    this.updateFilteredProducts(); 
                    
                    // close sorting popup if open
                    if (this.sortList) { 
                        this.toggle('sortList');   
                    }

                    if(pushHistory){
                        this.updateQueryParams();
                    }
                    

                    // go to page 1 of pagination
                    this.offset = 0;
                    let json = JSON.stringify(this.filteredProducts)
                    Cookies.set('vue-search', json);
                    Cookies.set('vue-search-reference', window.location.href);
                },
                matchesSearch(products, queryStringSrc = 'query') {
                    const search = this.formatString(this[queryStringSrc]);

                    let filtered = products;
                    if (search) {
                        filtered = filtered.filter(i => {
                            const t    = i.t   ? i.t   : '';
                            // const des  = i.des ? i.des : '';
                            return this.formatString(t).includes(search)   ||
                                   // this.formatString(des).includes(search) ||
                                   search === i.y                          ||
                                   search === i.pt.toLowerCase()           ||
                                   search === i.sf.toLowerCase();
                        });
                    }

                    return filtered;
                },
                matchesFromTos(products) {
                    let filtered = products;
                    for (const item of this.fromTos) {
                        const from = this[item.name].from ? parseInt(this[item.name].from) : null;
                        const to   = this[item.name].to   ? parseInt(this[item.name].to)   : null;

                        if (!from && !to) {
                            continue;
                        }

                        filtered = filtered.filter(i => {
                            const value = parseInt(item.value  ? i[item.key].value : i[item.key]);

                            if (from && to) {
                                return value >= from && value <= to;
                            } else if (from) {
                                return value >= from;
                            } else if (to) {
                                return value <= to;
                            }

                            return true;
                        });
                    }

                    return filtered;
                },
                matchesCheckboxes(products, brands = true) {
                    let filtered = products;

                    for (const checkbox of this.checkboxes) {
                        if (typeof this['selected' + checkbox.name] !== 'undefined' && this['selected' + checkbox.name].length && (brands ? true : checkbox.name !== 'Brands')) {
                            filtered = filtered.filter(i => {
                                let key = checkbox.value ? i[checkbox.key].value    : i[checkbox.key];
                                    key = checkbox.cert  ? this.getCertificate(key) : key;

                                return this.inSelected(checkbox.name, key);
                                });
                        }
                    }

                    return filtered;
                },
                toggle(item) {
                    this[item] = !this[item];
                },
                sort(dir) {
                    this.sortDir = dir;
                    this.update();
                },
                sortProducts(products) {
                    const sortDir = this.sortDir.toLowerCase();

                    let filtered = products;
                        filtered = sortDir === 'descdate'  ? products : filtered;
                        filtered = sortDir === 'ascdate'   ? filtered.reverse() : filtered;
                        filtered = sortDir === 'ascyear'   ? filtered.sort((a, b) => a.y - b.y) : filtered;
                        filtered = sortDir === 'descyear'  ? filtered.sort((a, b) => b.y - a.y) : filtered;
                        filtered = sortDir === 'descbrand' ? filtered.sort((a,b) => {
                            if (a.br < b.br) { return -1; }
                            if (a.br > b.br) { return  1; }
                            return 0;
                        }) : filtered;

                        filtered = sortDir === 'ascbrand' ? filtered.sort((a,b) => {
                            if (a.br > b.br) { return -1; }
                            if (a.br < b.br) { return  1; }
                            return 0;
                        }) : filtered;

                        filtered = sortDir === 'descprice' ? filtered.sort((a, b) => {
                            let totalA = a.p;
                                totalA = parseInt(a.re) > 0 ? totalA + parseInt(a.re) : totalA;
                            let totalB = b.p;
                                totalB = parseInt(b.re) > 0 ? totalB + parseInt(b.re) : totalB;

                            return totalA - totalB;
                        }) : filtered;

                        filtered = sortDir === 'ascprice' ? filtered.sort((a, b) => {
                            let totalA = a.p;
                                totalA = parseInt(a.re) > 0 ? totalA + parseInt(a.re) : totalA;
                            let totalB = b.p;
                                totalB = parseInt(b.re) > 0 ? totalB + parseInt(b.re) : totalB;

                            return totalB - totalA;
                        }) : filtered;

                    return filtered;
                },
                goTo(index) {
                    window.scrollTo(0,0);
                    this.offset = index;
                },
                getCheckboxName(key) {
                    for (const item of this.checkboxes) {
                        if (item.key === key) {
                            return item.name;
                        }
                    }

                    return '';
                },
                formatNumber(weight) {
                    return parseInt(weight).toLocaleString('no');
                },
                getModel(product) {
                    const title = product.t.replace(product.br + ' ', '');
                    
                    return title.charAt(0).toUpperCase() + title.slice(1);
                },
                getImageUrl(productImageUrl) { 
                    return `${productImageUrl}`;
                },
                formatString(string) {
                    return string.split(' ').join('').toLowerCase();
                },
                hasFrontImageType(product) {
                    return this.imageType === "front" && product.id && product.i || 
                           this.imageType === "plan"  && product.i;
                },
                hasPlanImageType(product) {
                    return this.imageType === "plan" && product.id && product.fp;
                },
                getCertificate(weight) {
                    return weight <= 3500 ? 'Klasse B' : 'Klasse C1';
                },
                formatPrice(price, regCost = 0) {
                    let total = price;
                        total = parseInt(regCost) > 0 ? total + parseInt(regCost) : total;
                        
                    return total ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')+ " kr" : '';
                },
                isImageType(string) {
                    return (this.imageType===string);
                },
                hasImageType(product)
                {
                    return (typeof product.pi[this.imageType] === 'string' && product.pi[this.imageType].length);
                },
                isLoggedIn() {
                    return Cookies.get('ma_session');
                },
                initOneSlideshow(id) {
                    if (!document.getElementById(id).classList.contains('is-active')) {
                        new Splide('#'+id, { perPage: 1, pagination : false }).mount();
                    }
                },
                initAllSlideshows() {
                    // initilalize alle slideshow
                    var elms = document.getElementsByClassName('splide');
                    for (let i = 0; i < elms.length; i++) {
                        if (!elms[i].classList.contains('is-active')) {
                            new Splide(elms[i], { type: 'loop', perPage: 1, pagination : false }).mount();
                        }
                    }
                },
                toggleCompareListItem(item){
                    // console.log('toggleCompareListItem()');
                    // console.log(item);
                    if(this.productsToCompareIds.includes(item.id)){
                        this.removeFromCompareList(item);
                    } else {
                        this.addToCompareList(item);
                    }
                },
                addToCompareList(item){

                    this.resetSearchToCompare();
                    this.productsToCompareIds.push(item.id);

                    Cookies.set('ck-pc', JSON.stringify(this.productsToCompareIds));

                    this.setProductsToCompare();
  
                    if(this.showProductsDiff){
                        this.markProductsDiff();
                    } else {
                        this.unmarkProductsDiff();
                    }
                   

                },
                setProductsToCompare(){
                    let products = [];
                    this.productsToCompareIds = JSON.parse(Cookies.get('ck-pc') ?? '[]');
    
                    this.products.forEach(p => {
                        if(this.productsToCompareIds.includes(p.id)){
                            products.push(p);
                        }
                    });

                    this.productsToCompare = products;

                    this.markProductsToCompare();
                    
                },
                markProductsToCompare(){
                    this.products.forEach(p => {
                        if(this.productsToCompareIds.includes(p.id)){
                            p.toCompare = true;
                        } else {
                            p.toCompare = false;
                        }
                    });
                },
                getProductsToCompare(){
                    let products = JSON.parse(Cookies.get('ck-pc') ?? '[]');

                    this.products.forEach(p => {
                        if(p.toCompare){
                            products.push(p);
                        }
                    });

                    return products;
                },
                removeFromCompareList(item){

                    this.productsToCompareIds = this.productsToCompareIds.filter(p => p != item.id);

                    Cookies.set('ck-pc', JSON.stringify(this.productsToCompareIds));

                    this.setProductsToCompare();
                    
                    if(this.showProductsDiff){
                        this.markProductsDiff();
                    } else {
                        this.unmarkProductsDiff();
                    }
                    
                },
                toggleCompareModal(){
                    this.compareModalOpen = !this.compareModalOpen;    
                    this.setProductCompareConfig();      

                    if(this.compareModalOpen && !window.PC_SWIPER){
                        ProductCompareHelper.setSwiper();
                    }
                    
                },
                isInProductsToCompare(product){
                    if (product.toCompare) {
                        return true;
                    }

                    return false;
                },
                markProductsDiff(){
                    let params = [];
                    this.unmarkProductsDiff();
                    
                    for (const key in this.productsToCompare[0]) {

                        for (let i = 1; i < this.productsToCompare.length; i++) {
                            let product = this.productsToCompare[0];
                            let productToCompare = this.productsToCompare[i];

                            if(product && productToCompare){
                                let config = this.productCompareConfig;
                                let valueComparable = ProductCompareHelper.getValue(product[key], config.compute, config.computeParams);
                                let valueToCompare = ProductCompareHelper.getValue(productToCompare[key], config.compute, config.computeParams);

                                if(valueComparable != valueToCompare){
                                    if(params.indexOf(key) !== -1){
                                        params.push(key); 
                                    }              
                                }
                            }
                        }
                    }

                    this.productCompareConfig.forEach(item => {
                        if(params.includes(item.key)){
                            item.mark = true;
                        }
                    });

                },
                unmarkProductsDiff(){
                    this.productCompareConfig.forEach(item => {
                            item.mark = false;
                    });
                },
                toggleProductsDiff(){
                    this.showProductsDiff = !this.showProductsDiff;

                    if(this.showProductsDiff){
                        this.markProductsDiff();
                    } else {
                        this.unmarkProductsDiff();1
                    }
                },
                maybePreventDefault(event) {

                    if (event.target.tagName !== 'IMG') {
                        event.preventDefault();
                    }
                },
                resetSearchToCompare(){
                    this.searchToCompareQuery = "";
                },
                searchToCompare(){
                    let filtered = this.products.slice();

                    filtered = this.matchesSearch(filtered, 'searchToCompareQuery');

                    this.searchToCompareResults = filtered.slice(0, 7);

                },
                initWindowScroll()
                {
                    document.addEventListener('scroll', this.initAllSlideshows);
                },
                checkWindowWidth(){
                    this.isMobile = window.innerWidth < 1366 ?  true :  false;

                    window.addEventListener("resize", e => {
                        this.isMobile = e.target.innerWidth < 1366 ?  true :  false;
                    });      
                }

            },
            computed: {
                qtyPlaceholders(){
                    let qty = 0;

                    if(this.isMobile){
                        qty = 2 - this.productsToCompare.length;
                    }else {
                        qty =  4 - this.productsToCompare.length;
                    }

                    if (qty < 0){
                        qty = 0;
                    }

                    return qty;
                },
                modalTriggerText(){
                   return this.compareModalOpen ? 'Skjul sammenligning' : 'Vis sammenligning';
                },
                toggleProductsDiffText(){
                    return this.showProductsDiff ? 'Skjul forskjeller' : 'Vis forskjeller';
                },
                qtyProductsToCompare(){
                    return this.productsToCompare.length;
                },
                brands() {
                    let brands = [];
                    for (const brand of this.allBrands) {
                        let filtered = this.products;
                        filtered = this.matchesCheckboxes(filtered, false);
                        filtered = this.matchesFromTos(filtered);
                        filtered = this.matchesSearch(filtered);

                        brands.push({
                            t: brand,
                            a: filtered.filter(item => item.br === brand).length,
                        });
                    }
                    
                    return brands.sort((a, b) => b.a - a.a);
                },
                series(){
                    const series = [];

                    for (const product of this.products) {

                        this.allBrands.forEach(brand => {
                            if(brand == product.br){
                                if(!series[brand]){
                                    series[brand] = [];
                                }
                                if (product.pl && !series[brand].some(i => i.t === product.pl)) {   
                                    series[brand].push({
                                        t: product.pl,
                                        a: this.products.filter(item => item.pl == product.pl).length
                                    });
                                }
                            }                      
                        });

                    }
                    return series;
                },
                domains() {
                    let domains = [];
                    for (const domain of this.allDomains) {
                        let filtered = this.products;
                            filtered = this.matchesCheckboxes(filtered, false);
                            filtered = this.matchesFromTos(filtered);
                            filtered = this.matchesSearch(filtered);

                        domains.push({
                            t: domain,
                            a: filtered.filter(item => item.ds.includes(domain)).length,
                        });
                    }
                   /*  brands = brands.sort((a, b) => b.a - a.a); */

                    return domains.slice(0, this.showAllDomains ? domains.length : 7);
                },
                retailers() {
                    const retailers = [];
                    for (const retailer of this.allRetailers) {
                        let filtered = this.products;
                            filtered = this.matchesCheckboxes(filtered);
                            filtered = this.matchesFromTos(filtered);
                            filtered = this.matchesSearch(filtered);

                        if (this.products.filter(item => item.rn === retailer).length) {
                            retailers.push({
                                t: retailer,
                                a: filtered.filter(item => item.rn === retailer).length
                            });
                        }
                    }
                    return retailers.slice(0, this.showAllRetailers ? retailers.length : 7);
                },
                locations() {
                    const locations = [];
                    for (const location of this.allLocations) {
                        let filtered = this.products;
                            filtered = this.matchesCheckboxes(filtered);
                            filtered = this.matchesFromTos(filtered);
                            filtered = this.matchesSearch(filtered);

                        if (this.products.filter(item => item.rc === location).length) {
                            locations.push({
                                t: location,
                                a: filtered.filter(item => item.rc === location).length
                            });
                        }
                    }
                    return locations.slice(0, this.showAllLocations ? locations.length : 7);
                },
                equipments() {
                    const equipments = [];
                    for (const eq of this.allEquipments) {
                        let filtered = this.products;
                            filtered = this.matchesCheckboxes(filtered);
                            filtered = this.matchesFromTos(filtered);
                            filtered = this.matchesSearch(filtered);

                        if (this.products.filter(item => item.e.includes(eq))) {
                                equipments.push({
                                    t: eq,
                                    a: filtered.filter(item => item.e.includes(eq)).length
                            });
                            
                        }
                    }
                    
                    return equipments.slice(0, this.showAllEquipments ? equipments.length : 7);
                },
                chassis() {
                    const chassis = [];
                    for (const ch of this.allChassis) {
                        let filtered = this.products;
                         // filtered = this.matchesCheckboxes(filtered);

                        if (this.products.filter(item => item.e.includes(ch))) {
                                chassis.push({
                                    t: ch,
                                    a: filtered.filter(item => item.ch.includes(ch)).length
                            });
                        }
                    }

                    return chassis.slice(0, this.showAllChassis ? chassis.length : 7);
                },
                campaigns() {
                    const campaigns = [];

                    if(this.allCampaigns.length === 0) {
                        campaigns[0] = {
                            t: true,
                            l: 'Kampanje',
                            a: 0
                        };
                        return campaigns;
                    }
                    
                    for (const c of this.allCampaigns) {
                        let filtered = this.products;
                            filtered = this.matchesCheckboxes(filtered);
                            filtered = this.matchesFromTos(filtered);
                            filtered = this.matchesSearch(filtered);

                            if (this.products.filter(item => item.c === c).length) {
                                campaigns.push({
                                    t: c,
                                    l: 'Kampanje',
                                    a: filtered.filter(item => item.c === c).length
                                })            
                            }
                    }
                    return campaigns;
                },
                salesforms() {
                    const salesforms = [];

                    for (const salesform of this.allSalesforms) {
                        if (salesform !== 'Auksjon' || salesform === 'Auksjon' && this.isLoggedIn()) {
                            if (this.products.filter(item => item.sf).length) {
                                salesforms.push({t: salesform});
                            }
                        }
                    }

                    this.availableSalesforms = salesforms.slice(0, this.showAllSalesforms ? salesforms.length : 7);

                    return this.availableSalesforms;
                },
                certificates() {
                    const certs = [];
                    for (const cert of this.allCertificates) {
                        if (this.products.filter(item => this.getCertificate(item.w) === cert).length) {
                            certs.push({t: cert});
                        }
                    }
                    
                    return certs.slice(0, this.showAllCertificates ? certs.length : 7);
                },
                gearboxes() {
                    const gearboxes = [];
                    for (const gearbox of this.allGearboxes) {
                        if (this.products.filter(item => (item.tr ? item.tr.value : '') === gearbox).length) {
                            gearboxes.push({t: gearbox});
                        }
                    }
                    
                    return gearboxes.slice(0, this.showAllGearboxes ? gearboxes.length : 7);
                },
                wheeldrives() {
                    const wheeldrives = [];
                    for (const wheeldrive of this.allWheeldrives) {
                        if (this.products.filter(item => (item.wd ? item.wd.value : '') === wheeldrive).length) {
                            wheeldrives.push({t: wheeldrive});
                        }
                    }
                    
                    return wheeldrives.slice(0, this.showAllWheeldrives ? wheeldrives.length : 7);
                },
                productTypes() {
                    const productTypes = [];
                    for (const productType of this.allProductTypes) {
                        if (this.products.filter(item => item.pt === productType).length) {
                            productTypes.push({t: productType});
                        }
                    }
                    
                    return productTypes.slice(0, this.showAllProductTypes ? productTypes.length : 7);
                },
                fuels() {
                    const fuels = [];
                    for (const fuel of this.allFuels) {
                        if (this.products.filter(item => item.f === fuel).length) {
                            fuels.push({t: fuel});
                        }
                    }
                    
                    return fuels.slice(0, this.showAllFuels ? fuels.length : 7);
                },
                paginatedProducts() {
                    const currentPage = this.offset * this.limit; 
                    return this.filteredProducts.slice(currentPage, currentPage + this.limit);
                },
                pages() {
                    if (!this.filteredProducts.length) {
                        return [];
                    }

                    // Array from 0 to n pages [0, 1, 2, ..., n]
                    const arr = [...Array(Math.ceil(this.filteredProducts.length / this.limit)).keys()]; 

                    if (arr.length < 7) {
                        return arr;
                    }
                    
                    // Show the same amount of pages before and after the selected page
                    const eitherSide = Math.floor(this.pagesVisible / 2);                                 

                    const length = arr.length;
                    const left   = this.offset - eitherSide > 0 ? this.offset - eitherSide : 0;
                    const limit  = length - this.pagesVisible;
                    
                    const start  = left  > limit ? limit : left;
                    const end    = start + this.pagesVisible;

                    return arr.slice(start, end);
                }
            }
        });


        app.component('modal', Modal); // Global registration
        app.component('input-checkbox', InputCheckbox); // Global registration
        app.component('ellipse-component', EllipseComponent); // Global registration
        app.component('product-compare-param', ProductCompareParam); // Global registration

        app.mount(container);
    }
}